import { useEffect, useState } from "react";
import {
  getStoredTheme,
  resolveTheme,
  setTheme as setThemeModule,
  subscribe,
} from "../lib/theme";

// React view over the theme module. Re-renders on theme change (toggle or OS).
export function useTheme() {
  const [theme, setThemeState] = useState(getStoredTheme);
  const [resolved, setResolved] = useState(() => resolveTheme());
  useEffect(
    () =>
      subscribe(() => {
        setThemeState(getStoredTheme());
        setResolved(resolveTheme());
      }),
    []
  );
  return { theme, resolved, setTheme: setThemeModule };
}
